import { apiClient } from '../../../shared/services/apiClient';
import type { ShippingAddress } from '../types/orderTypes';
import type { CartItem } from '../../../shared/store/cartSlice';

export interface OrderItem {
    productId: string;
    name: string;
    brand: string;
    price: number;
    qty: number;
    image: string;
    category: string;
}

export type OrderStatus = 'PENDING' | 'CONFIRMED' | 'SHIPPED' | 'DELIVERED' | 'CANCELLED';

export interface Order {
    _id: string;
    orderId: string;
    userId: string;
    items: OrderItem[];
    shippingAddress: ShippingAddress;
    paymentMethod: 'ONLINE';
    subtotal: number;
    courierCharge: number;
    gstRate: number;
    gstAmount: number;
    totalAmount: number;
    status: OrderStatus;
    createdAt: string;
    updatedAt: string;
}

export const orderService = {
    placeOrder(items: CartItem[], shippingAddress: ShippingAddress) {
        return apiClient.post<{ message: string; order: Order }>('/orders', {
            items,
            shippingAddress,
        });
    },

    getMyOrders(page = 1, limit = 10, status?: string) {
        return apiClient.get<{ orders: Order[]; total: number; page: number; limit: number }>(
            '/orders',
            { params: status ? { page, limit, status } : { page, limit } }
        );
    },

    getOrderById(id: string) {
        return apiClient.get<{ order: Order }>(`/orders/${id}`);
    },

    cancelOrder(id: string) {
        return apiClient.patch<{ message: string; order: Order }>(`/orders/${id}/cancel`);
    },

    getShippingPreview() {
        return apiClient.get<{ courierCharge: number }>('/orders/shipping-preview');
    },
};
